import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect } from 'react';

export function useQueryParam(paramName: string, defaultValue = ''): [string, (newValue: string | null) => void] {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get(paramName) ?? defaultValue;
  useEffect(() => {
    if (searchParams.get(paramName) === null && defaultValue !== '') {
      setSearchParams((prev) => {
        prev.set(paramName, defaultValue);
        return prev;
      });
    }
  }, [setSearchParams, searchParams.get(paramName) === null, defaultValue || ""])

  const setValue = useCallback(
    (newValue: string | null) => {
      const newParams = new URLSearchParams(searchParams);
      // If new value is default/null/undefined, remove the param for a clean URL
      if (newValue === defaultValue || newValue == null) {
        newParams.delete(paramName);
      } else {
        newParams.set(paramName, newValue);
      }
      setSearchParams(newParams, { replace: true });
    },
    [paramName, defaultValue, searchParams, setSearchParams]
  );

  return [value, setValue];
}